import { Form, Input, InputProps } from 'antd';
import { FormItemProps } from '@ant-design/compatible/lib/form';
import { NamePath } from 'antd/lib/form/interface';

import { InputLabelWithTooltip } from 'common/components/form/components/InputLabelWithTooltip';
import { FormInputProps } from 'common/components/form/models';
import styled from 'styled-components';

const StyledLabelContainer = styled.div`
    margin-bottom: 0.5rem;
`;

interface Props
    extends Omit<FormItemProps, 'label'>,
        Omit<InputProps, 'label' | 'name'>,
        FormInputProps {
    name: NamePath;
    label?: string;
    tooltip?: string;
    requiredMessage?: string;
}

export const FormInput = ({
    name,
    placeholder,
    label,
    required = true,
    disabled = false,
    hidden,
    autoComplete,
    requiredMessage,
    tooltip,
    help,
    validateStatus,
}: Props) => (
    <Form.Item
        name={name}
        label={
            tooltip ? (
                <InputLabelWithTooltip label={label || placeholder} tooltip={tooltip} />
            ) : (
                label || placeholder
            )
        }
        help={help}
        validateStatus={validateStatus}
        rules={[{ required, message: requiredMessage || `${label || placeholder} is required` }]}
    >
        <Input
            size="large"
            placeholder={placeholder || label}
            disabled={disabled}
            hidden={hidden}
            autoComplete={autoComplete}
        />
    </Form.Item>
);
